<template>
  <div>
    <form class="columns is-multiline is-padding">
      <div class="column is-12">
        <r-label
          :label="'Nom'"
          :red-check="true"
          :value="interlocuteur.last_name"></r-label>
        <v-input
          id="interlocuteur_last_name"
          name="interlocuteur_last_name"
          @input="val => interlocuteur.last_name = val"
          :model="interlocuteur.last_name"
          data-vv-as="Nom"
          v-validate="'min:2'"
          :errors-bag="errors"
          data-vv-value-path="val">
        </v-input>
      </div>
      <div class="column is-12">
        <r-label
          :label="'Prénom'"
          :is-required="false"
          :value="interlocuteur.first_name"></r-label>
        <v-input
          id="interlocuteur_first_name"
          name="interlocuteur_first_name"
          @input="val => interlocuteur.first_name = val"
          :model="interlocuteur.first_name"
          :errors-bag="errors"
          data-vv-value-path="val"
          data-vv-as="Prénom">
        </v-input>
      </div>
      <div class="column is-12">
        <r-label
          :label="'Fonction'"
          :is-required="false"
          :value="interlocuteur.role"></r-label>
        <v-input
          id="interlocuteur_role"
          name="interlocuteur_role"
          @input="val => interlocuteur.role = val"
          :model="interlocuteur.role"
          :errors-bag="errors"
          data-vv-value-path="val"
          data-vv-as="Fonction">
        </v-input>
      </div>
      <div class="column is-12">
        <r-label
          :label="'Téléphone'"
          :is-required="false"
          :value="interlocuteur.phone"
          :truncate="false"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-square">
              <span class="icon"><i class="fas fa-phone-office"></i></span>
            </a>
          </div>
          <div class="control is-expanded">
            <v-input
              id="interlocuteur_phone"
              name="interlocuteur_phone"
              @input="val => interlocuteur.phone = val"
              :model="interlocuteur.phone"
              v-validate="'min:10'"
              :errors-bag="errors"
              data-vv-value-path="val"
              :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
              data-vv-as="Téléphone">
            </v-input>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <r-label
          :label="'Adresse mail'"
          :is-required="false"
          :value="interlocuteur.email"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-square">
              <span class="icon"><i class="fas fa-paper-plane"></i></span>
            </a>
          </div>
          <div class="control is-expanded">
            <v-input
              id="interlocuteur_email"
              name="interlocuteur_email"
              @input="val => interlocuteur.email = val"
              :model="interlocuteur.email"
              v-validate="'email'"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Email">
            </v-input>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

const emptyInterlocuteur = {
  first_name: null,
  last_name: null,
  role: null,
  email: null,
  phone: null
}

export default {
  name: 'InterlocuteurForm',
  props: {
    source: {
      type: Object,
      default: () => ({})
    },
    paramsQuickview: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      interlocuteur: {}
    }
  },
  created () {
    this.interlocuteur = Object.assign({}, emptyInterlocuteur, cloneDeep(this.source) || {})
  },
  methods: {
    submitQuickview () {
      if (this.interlocuteur.first_name === '') this.interlocuteur.first_name = null
      if (this.interlocuteur.role === '') this.interlocuteur.role = null
      if (this.interlocuteur.phone === '') this.interlocuteur.phone = null
      if (this.interlocuteur.email === '') this.interlocuteur.email = null
      if (!this.interlocuteur.last_name) {
        return this.$toasted.global.danger('Le nom de l\'interlocuteur est obligatoire')
      }
      this.$emit('submitQuickview', { interlocuteur: this.interlocuteur })
    }
  }
}
</script>
